/** @format */

import axios from "axios";

//const BASE_URL = "http://localhost:5000/api"; // Το API του backend
//const BASE_URL2 = "http://localhost:5000/api/client";

// Relative URLs - nginx proxies /api/* to backend container (internal network)
const BASE_URL = "/api"; // Το API του backend
const BASE_URL2 = "/api/client";

export async function fetchAllDamData(fromDate = null) {
  try {
    let url = `${BASE_URL}/dam`;
    if (fromDate) {
      url += `?fromDate=${fromDate}`;
    }
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch DAM data");
    return await response.json();
  } catch (error) {
    console.error("❌ Error fetching all DAM data:", error);
    return [];
  }
}

export const fetchAllClients = async () => {
  const res = await axios.get(`${BASE_URL2}/all`);
  return res.data.clients;
};

export const addClientWithInitialMonth = async (client) => {
  return await axios.post(`${BASE_URL2}/settings`, client);
};

export const addMonthToClient = async (data) => {
  return await axios.post(`${BASE_URL2}/settings`, data);
};

export const fetchClientSettings = async (email) => {
  const response = await fetch(
    `${BASE_URL2}/all-settings?email=${encodeURIComponent(email)}`,
  );
  if (!response.ok) throw new Error("Failed to fetch client settings");
  return await response.json();
};

export const loginClient = async (email, password) => {
  const res = await fetch(`${BASE_URL2}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error("Invalid credentials");
  return res.json();
};
